export default {
  title: {
    list: 'Open API List',
    appList: 'Open API App List',
    configResponse: 'Customize Response',
    configRequest: 'Job Feed URL'
  },
  menu: 'Open API Management',
  label: {
    type: 'API Type',
    path: 'URL',
    responseKey: 'Response Key',
    dataKey: 'Data Source',
    isActive: 'On/Off',
    isRequireAuth: 'Auth required?',
    name: 'Name',
    randomGeneration: 'Generate',
    request: {
      customPath: 'Job Feed URL',
      fullPath: 'Preview: {path}',
      customParams: 'Request parameter settings',
      param: 'Parameters',
      isRequired: 'Required',
      defaultValue: 'Default Value',
      fixedValue: 'Set default value to'
    },
    companyId: 'Company ID',
    company: 'Company',
    rootCompany: 'Root Company',
    account: 'Account',
    appId: 'App ID',
    securityKey: 'App Security Key',
    appEnv: 'Environment',
    authType: 'Auth Type'
  },
  placeholder: {

  },
  btn: {

  },
  message: {
    needSetRequiredParam: 'This field is required.',
    duplicatedCustomPath: 'The Custom URL has been used',
    duplicatedOpenApiAppId: 'The same App ID already used in the same environment, please re-enter'
  },
  openApiType: {
    GET_COMPANY_APPLICANT_STATUS_CHANGE_REPORT: 'Get Company Applicant Status Change Record',
    SEARCH_JOB_APPLICANT_LIST: 'Search Job Applicant',
    SEARCH_COMPANY_JOB_LIST: 'Search Company Job'
  },
  authType: {
    BASIC: 'Basic Auth',
    CUSTOM_HTTP_DIGEST_AUTH: 'System Default'
  },
  appEnv: {
    test: 'Test',
    prod: 'Prod'
  }
}
